(function () {
  function parseTags(raw) {
    if (!raw) return [];
    return raw
      .split('|')
      .map((tag) => tag.trim())
      .filter(Boolean)
      .slice(0, 2);
  }

  function escapeHtml(text) {
    return text
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function renderTags(container, tags) {
    if (!container) return;
    container.innerHTML = tags
      .slice(0, 2)
      .map((tag) => `<span class="cross_sell-subtext__tag">${escapeHtml(tag)}</span>`)
      .join('');
    container.hidden = tags.length === 0;
  }

  const CROSS_SELL_SWIPER_MQ = window.matchMedia('(max-width: 1023px)');

  function destroyCrossSellSwiper(swiperEl) {
    if (!swiperEl) return;

    if (swiperEl._crossSellSwiper) {
      swiperEl._crossSellSwiper.destroy(true, true);
      swiperEl._crossSellSwiper = null;
    }

    swiperEl.classList.remove('swiper-initialized', 'swiper-horizontal', 'swiper-backface-hidden');
    const wrapper = swiperEl.querySelector('.swiper-wrapper');
    if (wrapper) {
      wrapper.style.transform = '';
      wrapper.style.transitionDuration = '';
    }
    swiperEl.querySelectorAll('.swiper-slide').forEach((slide) => {
      slide.style.width = '';
      slide.style.marginRight = '';
      slide.style.height = '';
    });
  }

  function setupCrossSellSwiper(swiperEl) {
    if (!swiperEl || typeof Swiper === 'undefined') return;

    if (!CROSS_SELL_SWIPER_MQ.matches) {
      destroyCrossSellSwiper(swiperEl);
      return;
    }

    if (swiperEl._crossSellSwiper) {
      swiperEl._crossSellSwiper.update();
      return;
    }

    swiperEl._crossSellSwiper = new Swiper(swiperEl, {
      slidesPerView: 3,
      spaceBetween: 16,
      watchOverflow: true,
      grabCursor: true,
      observer: true,
      observeParents: true,
      rewind: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
    });
  }

  function initCrossSellSwiper(container) {
    const swiperEl = container.querySelector('.cross_sell-wrapper.swiper');
    if (!swiperEl) return;

    const run = () => setupCrossSellSwiper(swiperEl);

    if (typeof Swiper !== 'undefined') {
      run();
    } else {
      window.addEventListener('load', run, { once: true });
    }

    if (container.dataset.crossSellSwiperBound === 'true') return;
    container.dataset.crossSellSwiperBound = 'true';

    const onBreakpointChange = () => setupCrossSellSwiper(swiperEl);
    if (typeof CROSS_SELL_SWIPER_MQ.addEventListener === 'function') {
      CROSS_SELL_SWIPER_MQ.addEventListener('change', onBreakpointChange);
    } else if (typeof CROSS_SELL_SWIPER_MQ.addListener === 'function') {
      CROSS_SELL_SWIPER_MQ.addListener(onBreakpointChange);
    }
  }

  function initCrossSell(container) {
    if (!container || container.dataset.crossSellInit === 'true') return;

    container.dataset.crossSellInit = 'true';
    initCrossSellSwiper(container);

    const subtext = container.querySelector('.cross_sell-subtext');
    const titleEl = subtext?.querySelector('.cross_sell-subtext__title');
    const tagsEl = subtext?.querySelector('.cross_sell-subtext__tags');
    const thumbnails = container.querySelectorAll('.cross_sell-thumbnail[data-cross-sell-title]');

    if (!subtext || !titleEl || !thumbnails.length) return;

    const defaultThumbnail = thumbnails[0];
    const wrapper = container.querySelector('.cross_sell-wrapper');

    const setSubtext = (title, tags) => {
      titleEl.textContent = title;
      if (tagsEl) renderTags(tagsEl, tags);
    };

    const activateThumbnail = (thumbnail) => {
      thumbnails.forEach((item) => item.classList.remove('cross_sell-thumbnail--active'));
      thumbnail.classList.add('cross_sell-thumbnail--active');
      setSubtext(thumbnail.dataset.crossSellTitle, parseTags(thumbnail.dataset.crossSellTags));
    };

    const resetSubtext = () => {
      activateThumbnail(defaultThumbnail);
    };

    activateThumbnail(defaultThumbnail);

    if (wrapper) {
      wrapper.addEventListener('mouseover', (event) => {
        const thumbnail = event.target.closest('.cross_sell-thumbnail[data-cross-sell-title]');
        if (!thumbnail || !wrapper.contains(thumbnail)) return;
        activateThumbnail(thumbnail);
      });

      wrapper.addEventListener('mouseleave', resetSubtext);

      wrapper.addEventListener('focusin', (event) => {
        const thumbnail = event.target.closest('.cross_sell-thumbnail[data-cross-sell-title]');
        if (!thumbnail || !wrapper.contains(thumbnail)) return;
        activateThumbnail(thumbnail);
      });

      wrapper.addEventListener('focusout', (event) => {
        if (wrapper.contains(event.relatedTarget)) return;
        resetSubtext();
      });
    }

    const updateVariantImages = (variantTitle) => {
      if (!variantTitle) return;

      const currentLink = container.querySelector('.cross_sell-thumbnail--current');
      const currentImg = container.querySelector('[data-cross-sell-current-image]');
      const currentVariants = container.querySelector('[data-cross-sell-current-variants]');

      if (currentVariants && currentLink && currentImg) {
        const variants = JSON.parse(currentVariants.textContent);
        const currentMatch = variants.find((variant) => variant.title === variantTitle);
        if (currentMatch) {
          currentImg.src = currentMatch.image;
          currentLink.href = currentMatch.url;
        }
      }

      container.querySelectorAll('.cross-sell-variant-data').forEach((script) => {
        const handle = script.dataset.handle;
        const img = container.querySelector(`[data-cross-sell-handle="${handle}"]`);
        const link = img?.closest('.cross_sell-thumbnail');
        if (!img || !link) return;

        const variants = JSON.parse(script.textContent);
        const match = variants.find((variant) => variant.title === variantTitle);
        if (match) {
          img.src = match.image;
          link.href = match.url;
        }
      });
    };

    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const productInfo = container.closest('product-info');
        if (!productInfo || event.data.sectionId !== productInfo.dataset.section) return;
        updateVariantImages(event.data.variant?.title);
      });
    }
  }

  function initAll() {
    document.querySelectorAll('.cross_sell-container').forEach(initCrossSell);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll?.('.cross_sell-container').forEach(initCrossSell);
  });
})();
